// import { useOutletContext } from "react-router-dom";

export default function Loader({darkMode = true}) {
    //  const { darkMode } = useOutletContext();
    return (
        <div className={`fixed inset-0 z-[9999] flex items-center justify-center ${
            darkMode 
                ? 'bg-[#0f1419]' 
                : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50'
        }`}>
            
            {/* Glass Card */}
            <div className={`relative flex flex-col items-center gap-5 px-10 py-8 rounded-3xl backdrop-blur-2xl shadow-[0_8px_32px_0_rgba(31,38,135,0.37)] border transition-all duration-300 ${
                darkMode 
                    ? 'bg-slate-800/60 border-slate-700/40' 
                    : 'bg-white/70 border-white/30'
            }`}>
                
                {/* Multi-ring Spinner */}
                <div className="relative w-20 h-20">
                    {/* Ring 1 */}
                    <div className={`absolute inset-0 rounded-full border-[3px] border-transparent animate-spin ${
                        darkMode 
                            ? 'border-t-blue-400 border-r-cyan-400' 
                            : 'border-t-blue-600 border-r-indigo-600'
                    }`} style={{ animationDuration: '1.2s' }}></div>
                    
                    {/* Ring 2 */}
                    <div className={`absolute inset-[12%] rounded-full border-[3px] border-transparent animate-spin ${
                        darkMode 
                            ? 'border-b-purple-400 border-l-pink-400' 
                            : 'border-b-purple-600 border-l-pink-600'
                    }`} style={{ animationDuration: '1.8s', animationDirection: 'reverse' }}></div>
                    
                    {/* Center Glow */}
                    <div className={`absolute inset-[35%] rounded-full animate-pulse ${
                        darkMode 
                            ? 'bg-gradient-to-br from-blue-400 to-purple-400 shadow-[0_0_15px_rgba(96,165,250,0.6)]' 
                            : 'bg-gradient-to-br from-blue-600 to-purple-600 shadow-[0_0_15px_rgba(59,130,246,0.6)]'
                    }`}></div>
                </div>
                
                {/* Text */}
                <div className="flex flex-col items-center gap-3">
                    <h3 className={`text-lg font-bold tracking-wide ${
                        darkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                        Loading
                    </h3>
                    
                    {/* Progress Dots */}
                    <div className="flex gap-1.5">
                        {[0, 1, 2].map((i) => (
                            <div 
                                key={i}
                                className={`w-2 h-2 rounded-full animate-bounce ${
                                    darkMode ? 'bg-blue-400' : 'bg-blue-600'
                                }`}
                                style={{ animationDelay: `${i * 0.15}s` }}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
